
















import { Component, Vue } from "vue-property-decorator";
import Base from "@/template/public/Base.vue";
import NewsItem from "@/components/NewsItemNA.vue";
@Component({
  components: {
    NewsItem
  }
})
export default class ColumnDetail extends Base {
  public appId = "";
  public finished = false;
  newsList: any = [];
  columnId: string = "";
  mounted() {
    this.appId = (this.$route.query.appId as string) || "";
    this.columnId = (this.$route.query.columnId as string) || "";
  }
  onRefresh(done: any) {
    this.newsList = [];
    this.getnewsList(this.columnId);
    done();
  }
  onLoad(done: any) {
    this.getnewsList(this.columnId);
    done();
  }
  // 获取新闻列表
  async getnewsList(columnId: string) {
    let res = [];
    if (this.newsList.length) {
      res = await this.request.getnewsList({
        appId: this.appId,
        isCarousel: false,
        columnId,
        lastId: this.newsList[this.newsList.length - 1].id,
        lastSortNo: this.newsList[this.newsList.length - 1].sortNo,
        lastOnlineTime: this.newsList[this.newsList.length - 1].onlineTime
      });
      this.newsList = [...this.newsList, ...res.data.news];
    } else {
      res = await this.request.getnewsList({
        appId: this.appId,
        isCarousel: false,
        columnId
      });
      this.newsList = res.data.news;
    }
    if (res.data.news.length == 0) {
      this.finished = true;
    } else {
      this.finished = false;
    }
  }
  newItemClick(item: any) {
    window.open(item.url);
  }
}
